module.exports = __webpack_public_path__ + "img/back_black.82f5886a.svg";